import { createRouter, createWebHistory } from 'vue-router'

import { useAuthStore } from '@/stores/auth'

const router = createRouter({
  history: createWebHistory(),
  routes: [
    // --- Giriş GEREKTİRMEYEN sayfalar ---
    //
    // Ana sayfa artık giriş formu değil. Sebebi ikili: uygulamayı
    // tanımayan birine "kullanıcı adı ve parola" göstermek onu geri
    // çeviriyor; ve Google'ın kısıtlı kapsam doğrulaması herkese açık
    // bir ana sayfa, gizlilik politikası ve kullanım koşulları istiyor.
    {
      path: '/',
      component: () => import('@/layouts/PublicLayout.vue'),
      children: [
        { path: '', name: 'landing', component: () => import('@/pages/public/LandingPage.vue') },
        { path: 'privacy', name: 'privacy', component: () => import('@/pages/public/PrivacyPage.vue') },
        { path: 'terms', name: 'terms', component: () => import('@/pages/public/TermsPage.vue') },
        // DAVET BAĞLANTISI. E-postadaki adres burası ve rota yoktu:
        // davet edilen herkes "sayfa bulunamadı" görüyordu.
        // Giriş gerektirmiyor — davet edilenin çoğu zaman hesabı yok.
        {
          path: 'invite/:token',
          name: 'invite',
          component: () => import('@/pages/public/InvitePage.vue'),
        },
      ],
    },
    {
      path: '/app',
      component: () => import('@/layouts/AppLayout.vue'),
      meta: { requiresAuth: true },
      children: [
        // PANEL ARTIK KÖKTE DEĞİL: kök, giriş gerektirmeyen tanıtım
        // sayfası oldu. Menü bağlantıları rota ADI kullandığı için
        // hiçbiri değişmedi; yalnızca yol taşındı.
        // /app TEK BAŞINA da panele gitmeli.
        //
        // Eşleşen alt rota olmadığında AppLayout çiziliyor ama RouterView
        // boş kalıyordu: kenar çubuğu duruyor, içerik alanı bomboş ve
        // konsolda hata yok. Menü bağlantıları rota ADI kullandığı için
        // kimse fark etmiyordu — adresi elle yazan ya da yer imine
        // ekleyen görüyordu.
        { path: '', redirect: { name: 'dashboard' } },
        { path: 'dashboard', name: 'dashboard', component: () => import('@/pages/DashboardPage.vue') },
        { path: 'accounts', name: 'accounts', component: () => import('@/pages/AccountsPage.vue') },
        { path: 'transactions', name: 'transactions', component: () => import('@/pages/TransactionsPage.vue') },
        // KREDİ DETAYI: bölüm değil, tek bir kredinin sayfası.
        //
        // '/app/debts' bir bölümdü ve içinde üç sekme vardı; kullanıcı
        // oraya menüden gidiyordu. Artık Hesaplar listesindeki krediye
        // tıklayarak geliniyor ve adres hangi krediye bakıldığını
        // söylüyor.
        // Mevduat detayı: faiz tablosu, oran değişikliği, bozma.
        // Krediyle aynı kalıp — listeden tıklanarak geliniyor.
        // Mevduat açma AYRI SAYFA, çekmece değil: formun asıl işi rakam
        // girmek değil karar verdirmek ve o karar dönem dönem faiz
        // tablosuna bakılarak veriliyor. Tablo dar bir çekmeceye
        // sığmıyordu. ':id' rotasından ÖNCE: sonra gelseydi Fiber gibi
        // vue-router da "new" dizesini kimlik sanardı.
        {
          path: 'deposits/new',
          name: 'deposit-new',
          component: () => import('@/pages/DepositNewPage.vue'),
        },
        {
          path: 'deposits/:id',
          name: 'deposit-detail',
          component: () => import('@/pages/DepositDetailPage.vue'),
        },
        {
          path: 'loans/:id?',
          name: 'loan-detail',
          component: () => import('@/pages/DebtsPage.vue'),
        },
        {
          path: 'budgets',
          name: 'budgets',
          component: () => import('@/pages/PlanningPage.vue'),
        },
        {
          path: 'portfolio',
          name: 'portfolio',
          component: () => import('@/pages/PortfolioPage.vue'),
        },
        {
          path: 'inbox',
          name: 'inbox',
          component: () => import('@/pages/InboxPage.vue'),
        },
        {
          path: 'categories',
          name: 'categories',
          component: () => import('@/pages/CategoriesPage.vue'),
        },
        { path: 'settings', name: 'settings', component: () => import('@/pages/SettingsPage.vue') },
        {
          path: 'household',
          name: 'household',
          component: () => import('@/pages/HouseholdPage.vue'),
        },
      ],
    },
    {
      path: '/auth',
      component: () => import('@/layouts/AuthLayout.vue'),
      meta: { guestOnly: true },
      children: [
        { path: 'sign-in', name: 'sign-in', component: () => import('@/pages/auth/SignInPage.vue') },
        { path: 'sign-up', name: 'sign-up', component: () => import('@/pages/auth/SignUpPage.vue') },
        {
          path: 'forgot-password',
          name: 'forgot-password',
          component: () => import('@/pages/auth/ForgotPasswordPage.vue'),
        },
        {
          path: 'reset-password',
          name: 'reset-password',
          component: () => import('@/pages/auth/ResetPasswordPage.vue'),
        },
      ],
    },
    // OAuth GERİ DÖNÜŞÜ ESKİ YOLA GELİYOR.
    //
    // Panel /app altına taşındığında Google Cloud'daki kayıtlı adres
    // /settings olarak kalmıştı ve o yol artık yok: kullanıcı Google'da
    // izin verip geri döndüğünde "sayfa bulunamadı" görüyordu —
    // bağlantı aslında kurulabilirdi ama kod hiç okunmuyordu.
    //
    // SORGU KORUNUYOR: yönlendirme `?code=...` parametresini taşımazsa
    // ayarlar sayfası okuyacak bir şey bulamaz.
    //
    // Yol kalıcı: kayıtlı yönlendirme adresini değiştirmek Google
    // Cloud'da elle düzenleme gerektiriyor ve eski yer imleri de buraya
    // düşüyor.
    // --- Eski adresler ---
    //
    // Panel /app altına taşındı ve kökteki yollar tanıtım sayfasına
    // yer açtı. Taşımadan önce kaydedilmiş yer imleri ve paylaşılmış
    // bağlantılar "sayfa bulunamadı" vermesin.
    //
    // Raporlar sayfası ayrıca KALDIRILDI; içeriği panelin bir bölümü.
    // '/app/debts' ARTIK BÖLÜM DEĞİL: yer imi ve eski bağlantılar
    // hesap listesine düşüyor — kredi, kart ve kişisel borç orada.
    { path: '/app/debts', redirect: { name: 'accounts' } },
    { path: '/debts', redirect: { name: 'accounts' } },
    { path: '/app/reports', redirect: { name: 'dashboard' } },
    { path: '/reports', redirect: { name: 'dashboard' } },
    ...(
      [
        'accounts',
        'transactions',
        'debts',
        'budgets',
        'portfolio',
        'inbox',
        'categories',
        'household',
      ] as const
    ).map((name) => ({ path: `/${name}`, redirect: { name } })),

    { path: '/settings', redirect: (to) => ({ name: 'settings', query: to.query }) },

    { path: '/:pathMatch(.*)*', name: 'not-found', component: () => import('@/pages/NotFoundPage.vue') },
  ],

  scrollBehavior(_to, _from, saved) {
    return saved ?? { top: 0 }
  },
})

// Oturum yalnızca bir kez sunucudan tazelenir; her yönlendirmede /me çağırmak
// gereksiz istek üretir.
let hydrated = false

router.beforeEach(async (to) => {
  const auth = useAuthStore()

  if (auth.isAuthenticated && !hydrated) {
    hydrated = true
    await auth.hydrate()
  }

  if (to.meta.requiresAuth && !auth.isAuthenticated) {
    // Kullanıcı gitmek istediği yeri kaybetmesin: girişten sonra oraya döner.
    return { name: 'sign-in', query: { redirect: to.fullPath } }
  }

  if (to.meta.guestOnly && auth.isAuthenticated) {
    // DÖNÜŞ ADRESİ KORUNUYOR.
    //
    // Koşulsuz panele atıyordu ve davet akışını kesiyordu: kullanıcı
    // davet bağlantısından kayıt sayfasına geliyor, kaydolur olmaz bu
    // koruma devreye girip paneli açıyor ve davet hiç kabul edilmemiş
    // oluyordu. Sayfanın kendi yönlendirmesi çalışamıyordu bile —
    // koruma ondan önce davranıyor.
    const redirect = to.query.redirect
    if (typeof redirect === 'string' && redirect.startsWith('/')) {
      return redirect
    }
    return { name: 'dashboard' }
  }

  return true
})

export default router
